// Pastas de imagens
import { ALL_ILLUSTRATIONS } from './illustrations/import_all_illustrations';
import { ALL_RECOMENDA } from './dados-recomenda/allRecomenda';
import { ALL_MY_ACCOUNT } from './my-account/import_all_myaccount';
import { ALL_HOME } from './home/import_all_home';
// Others
import entrar from './others/entrar.jpg';
import remember from './others/remember.jpg';
import imagemIndisponivel from './others/image_unavailable.jpg';
import imgLocadoraIndisponivelComBorda from './others/imgLocadoraIndisponivelComBorda.jpg';
import imgLocadoraIndisponivelSemBorda from './others/imgLocadoraIndisponivelSemBorda.jpg';
import AeroplaneAirTravel from './others/aeroplane-air-travel.jpg';
import avatarMasculino from './others/voala_avatar_homem_2.png';
import avatarFeminino from './others/voala_avatar_mulher_2.png';
import verMapa from './others/ver_mapa.jpg';
import backTogether from './others/backTogether.jpg';
import GooglePlay from './others/GooglePlay.jpg';
import AppStore from './others/AppStore.jpg';
import cashbackBlackFrinday2020 from './others/cashbackBlackFrinday2020.png';
// Logo Voala
import logoVoala from './logo/logo_voala.svg';
import voalaLoading from './logo/voala_loading.png';
import logoVoalaSimples from './logo/logo-voala-simples.svg';
// Logo Companhia aerea
import logoAvianca from './logo-companhias-aereas/logo_avianca.svg';
import logoGol from './logo-companhias-aereas/logo_gol.svg';
import logoLatam from './logo-companhias-aereas/logo_latam.svg';
import logoDelta from './logo-companhias-aereas/logo_delta.png';
import logoAzul from './logo-companhias-aereas/logo_azul.svg';
import logoTAPPortugal from './logo-companhias-aereas/logo_tap_portugal.png';
import logoAirEuropa from './logo-companhias-aereas/logo_air_europa.png';
import logoIberia from './logo-companhias-aereas/logo_iberia.png';
import logoAmericanAirLines from './logo-companhias-aereas/logo_american_airlines.png';
import logoAirFrance from './logo-companhias-aereas/logo_airFrance.png';
import logoKlm from './logo-companhias-aereas/logo_klm.png';
import logoAlaska from './logo-companhias-aereas/logo_alaska.png';
import logoAerolineasArgentinas from './logo-companhias-aereas/logo_aero_argentinas.png';
import logoVueling from './logo-companhias-aereas/logo_vueling.png';

// Bandeira de cartão
import logoVisa from './cards/visa.svg';
import logoMasterCard from './cards/mastercard.svg';
import logoDiners from './cards/diners.svg';
import logoAmex from './cards/amex.svg';
import logoHipercard from './cards/hipercard.svg';
import logoElo from './cards/elo.svg';
// Cartoes Footer
import logoVisaFooter from './cards/footer/ic_visa.png';
import logoMasterCardFooter from './cards/footer/ic_mastercard.png';
import logoAmexFooter from './cards/footer/ic_amex.png';
import logoEloFooter from './cards/footer/ic_elo.png';

// Custom icons
import AirConditioner from './custom-icons/air-direction.svg';
import Balcony from './custom-icons/balcony.svg';
import Fan from './custom-icons/fan.svg';
import Hairdryer from './custom-icons/hairdryer.svg';
import Sofa from './custom-icons/sofa.svg';
import Wardrobe from './custom-icons/wardrobe.svg';
import Fridge from './custom-icons/fridge.svg';
// Icones do mapa
import pinMaps from './icons-maps/pin-maps.svg';
import pinMapsActive from './icons-maps/pin-maps-active.svg';
// Logos Locadoras
import logoLocaliza from './cars/logo-localiza.png';
import logoMovida from './cars/logo-movida.png';
import logoUnidas from './cars/logo-unidas.png';
import carImageDefault from './cars/car-default.jpg';
import logoCoris from './others/logo_coris.png';
import trustpilot from './others/trustpilot.png';

// Imagens Materias Blog
import primeiraMateriaBlog from './materias-blog/blog1.jpg';
import segundaMateriaBlog from './materias-blog/blog2.png';
import terceiraMateriaBlog from './materias-blog/blog3.png';

// Imagens Cross Selling
import bgCrossAereo from './cross-selling/bg_CrossAereo.jpg';
import bgCrossCarro from './cross-selling/bg_CrossCarro.jpg';
import bgCrossHotel from './cross-selling/bg_CrossHotel.jpg';
import bgCrossSeguro from './cross-selling/bg_CrossSeguro.jpg';

// Loaders animations

import hotelLoader from './loaders/hotelLoader.gif';
import flightLoader from './loaders/flightLoader.gif';
import packageLoader from './loaders/packageLoader.gif';
import carLoader from './loaders/carLoader.gif';
import user from './others/user-solid.svg';

import bannertravel from './banner.png';
import bannertravelMobile from './banner_mobile.png'
import popup from './popupteste.png'

export const images = {
  // Pastas de imagens
  illustrations: ALL_ILLUSTRATIONS,
  recomenda: ALL_RECOMENDA,
  myAccount: ALL_MY_ACCOUNT,
  home: ALL_HOME,
  // Others
  entrar,
  remember,
  imagemIndisponivel,
  imgLocadoraIndisponivelComBorda,
  imgLocadoraIndisponivelSemBorda,
  AeroplaneAirTravel,
  avatarMasculino,
  avatarFeminino,
  verMapa,
  backTogether,
  GooglePlay,
  AppStore,
  cashbackBlackFrinday2020,
  // Logo Voala
  logo_voala: logoVoala,
  voalaLoading,
  logoVoalaSimples,
  // Logo Companhia aerea
  logoAvianca,
  logoCompanhiasAereas: {
    O6: logoAvianca,
    G3: logoGol,
    AD: logoAzul,
    JJ: logoLatam,
    LA: logoLatam,
    DL: logoDelta,
    TP: logoTAPPortugal,
    UX: logoAirEuropa,
    IB: logoIberia,
    AA: logoAmericanAirLines,
    AF: logoAirFrance,
    KL: logoKlm,
    AS: logoAlaska,
    AR: logoAerolineasArgentinas,
    VY: logoVueling,
  },
  // Bandeira de cartão
  logoVisa,
  logoMasterCard,
  logoCartoes: {
    visa: logoVisa,
    mastercard: logoMasterCard,
    amex: logoAmex,
    diners: logoDiners,
    elo: logoElo,
    hipercard: logoHipercard,
  },
  logoCartoesFooter: {
    visa: logoVisaFooter,
    mastercard: logoMasterCardFooter,
    amex: logoAmexFooter,
    elo: logoEloFooter,
  },
  // Custom icons
  customIcons: {
    AirConditioner,
    Balcony,
    Fan,
    Hairdryer,
    Sofa,
    Wardrobe,
    Fridge,
  },
  // Icones do mapa
  pinMaps,
  pinMapsActive,
  logoLocadoras: {
    localiza: logoLocaliza,
    movida: logoMovida,
    unidas: logoUnidas,
  },
  logoSeguros: {
    april: logoCoris,
    coris: logoCoris
  },
  carImageDefault,
  imgMateriasBlog: {
    primeiraMateriaBlog,
    segundaMateriaBlog,
    terceiraMateriaBlog,
  },
  trustpilot,
  imgCross: {
    bgCrossAereo,
    bgCrossCarro,
    bgCrossHotel,
    bgCrossSeguro,
  },
  loaders: {
    hotelLoader,
    flightLoader,
    packageLoader,
    carLoader,
  },
  user,
  bannertravel,
  bannertravelMobile,
  popup
};
